import { createRoot } from 'react-dom/client';
import DevicePickerService from 'Shared/device_picker_service';
import { KeyboardNavigation } from 'Shared/keyboard_navigation';
import { DevicePickerModal } from 'Shared/DevicePickerModal';
import { Initializer } from 'Shared/chakra-initialize';
import { initializeReactQuery } from 'Shared/react-query-initialize';

new KeyboardNavigation({
   keys: {
      '/': deviceNavigator,
   },
});

export default function deviceNavigator(options = null) {
   if (App.lang === 'en') {
      const node = document.createElement('div');
      document.body.appendChild(node);
      const root = createRoot(node);
      const DevicePickerWithChakra = new Initializer(DevicePickerModal);
      root.render(
         initializeReactQuery(
            <DevicePickerWithChakra
               defaultIsOpen={true}
               onSelect={device => (window.location.href = device.url)}
               treeNavigationProps={'showAreaButtons'}
            />
         )
      );
      return;
   }
   if (!options) {
      options = {
         initialView: 'COLUMN',
      };
   }
   DevicePickerService.selectDevice(options).then(device => {
      if (device) {
         const encodedTitle = DevicePickerService.encodeDeviceTitle(device);
         window.location = `/Device/${encodedTitle}`;
      }
   });
}
